import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "../BrandLogo";
import appStoreBadge from "../../assets/images/app-store-badge.svg";

const APP_STORE_URL = "https://apps.apple.com/app/id6761911634";

const COLUMNS: { heading: string; links: { to: string; label: string }[] }[] = [
  {
    heading: "Products",
    links: [
      { to: "/products/quotes", label: "Quotes and negotiation" },
      { to: "/products/travel", label: "Travel" },
      { to: "/products/budget", label: "Budget and versions" },
      { to: "/products/guests", label: "Guest list" },
      { to: "/products/automate", label: "Automate" },
      { to: "/venue-finder", label: "AI venue finder" },
    ],
  },
  {
    heading: "Use cases",
    links: [
      { to: "/use-cases/conferences", label: "Conferences and summits" },
      { to: "/use-cases/offsites", label: "Team offsites" },
      { to: "/use-cases/launches", label: "Product launches" },
      { to: "/use-cases/all-hands", label: "All-hands" },
      { to: "/use-cases/client-dinners", label: "Customer dinners" },
      { to: "/corporate-event-planner", label: "Instead of a planner" },
      { to: "/event-management-company", label: "Instead of an agency" },
    ],
  },
  {
    heading: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/pricing", label: "Pricing" },
      { to: "/blog", label: "Blog" },
      { to: "/partners", label: "For partners" },
      { to: "/contact", label: "Contact" },
    ],
  },
];

/* Footer for Dusk pages. This ships on the global market only (the homepage it
   belongs to is comtev.com's), so the links need no market gate. */
const DuskFooter: React.FC = () => (
  <footer className="dusk-footer">
    <div className="dusk-wrap">
      <div className="dusk-footer-grid">
        <div className="dusk-footer-brand">
          <Link to="/" aria-label="Comtev home">
            <BrandLogo
              surface="dark"
              className="dusk-footer-logo"
              width={154}
              height={28}
            />
          </Link>
          <p className="dusk-footer-tag">
            AI corporate event planning software. Built in the UK.
          </p>
          <div className="dusk-footer-soc">
            <a
              href="https://x.com/comtevltd"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Comtev on X"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/comtev/about/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Comtev on LinkedIn"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/comtev_official/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Comtev on Instagram"
            >
              <svg
                viewBox="0 0 24 24"
                aria-hidden="true"
                style={{ fill: "none" }}
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
          </div>
          <a
            href={APP_STORE_URL}
            className="dusk-footer-store"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download Comtev on the App Store"
          >
            <img
              src={appStoreBadge}
              alt="Download on the App Store"
              loading="lazy"
            />
          </a>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.heading}>
            <h2 className="dusk-footer-h">{col.heading}</h2>
            <ul className="dusk-footer-links">
              {col.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="dusk-footer-bot">
        <span>&copy; {new Date().getFullYear()} Comtev LTD</span>
        <nav aria-label="Legal">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/personal">Personal events</Link>
        </nav>
      </div>
    </div>
  </footer>
);

export default DuskFooter;
